import React from 'react';

const FeaturesSection = () => {
  const features = [
    {
      title: "INNOVATION",
      description: "Pioneering breakthrough technologies that redefine standards in aerospace engineering."
    },
    {
      title: "DEDICATION", 
      description: "Delivering unparalleled accuracy and reliability in every component and system we create."
    },
    {
      title: "FUTURE",
      description: "Sustaining today's Earth while pioneering tomorrow's solutions."
    }
  ];

  return (
    <section style={{ padding: '60px 20px 20px', color: '#fff' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h3 style={{
          fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
          fontWeight: '100',
          color: 'white',
          marginBottom: '0.6rem',
          letterSpacing: '0.03em',
          textAlign: 'center'
        }}>
          MAKING BIG CHANGES ONE SMALL DESIGN CHOICE AT A TIME
        </h3>
        
        <p style={{
          fontSize: '1.1rem',
          color: '#cbd5e1',
          lineHeight: '1.7',
          textAlign: 'center',
          maxWidth: '900px',
          margin: '0 auto 2.5rem'
        }}>
          Eve operates on liquid methane and liquid oxygen, producing an exhaust stream composed primarily of water vapor and carbon dioxide, with negligible soot or sulfur compounds. Under full-thrust conditions, methalox combustion results in on the order of 230kg/s of carbon dioxide during powered ascent. Compared to kerosene based propulsion, methane oxygen systems exhibit lower particulate emissions and cleaner exhaust, supporting more consistent engine performance across repeated flights.
          <br />   <br />
          In combination with full reusability and continuous reflight, Eve’s operational model is designed to reduce lifecycle emissions per mission by distributing manufacturing, infrastructure, and refurbishment impacts across a high number of flights, lowering the effective environmental footprint per unit of delivered payload.
        </p>
        <div className="features-scroll-row" style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '3rem',
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'thin',
        }}>
                {}
                <style>{`
                  .features-scroll-row {
                    display: flex !important;
                    flex-direction: row;
                    overflow-x: auto !important;
                    gap: 1.2rem !important;
                    padding-bottom: 0.5rem;
                    scrollbar-width: thin;
                    -webkit-overflow-scrolling: touch;
                    flex-wrap: nowrap !important;
                    white-space: nowrap !important;
                    justify-content: center !important;
                  }
                  @media (max-width: 900px) {
                    .features-scroll-row {
                      justify-content: flex-start !important;
                    }
                  }
                  .features-scroll-row > div {
                    min-width: 340px !important;
                    max-width: 340px !important;
                    flex: 0 0 340px !important;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    word-break: break-word;
                    white-space: normal;
                    overflow-wrap: break-word;
                    box-sizing: border-box;
                    padding: 2rem !important;
                  }
                  .features-scroll-row > div h3 {
                    font-size: 1.5625rem !important;
                    font-weight: 300 !important;
                    margin-bottom: 0.2rem !important;
                    color: white !important;
                    line-height: 1.2 !important;
                  }
                  .features-scroll-row > div p {
                    color: #9ca3af !important;
                    line-height: 1.6 !important;
                    font-size: 1.25rem !important;
                    white-space: normal !important;
                    word-break: break-word !important;
                    max-width: 100% !important;
                    overflow-wrap: break-word;
                    display: block;
                    margin: 0 !important;
                  }
                `}</style>
          
          {features.map((feature, index) => (
            <div 
              key={index}
              style={{
                padding: '2rem',
                borderRadius: '12px',
                backgroundColor: 'transparent',
                border: '1px solid transparent',
                transition: 'all 0.3s ease, border-color 0.3s ease',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                outline: 'none'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 0 20px rgba(82, 39, 255, 0.6), 0 8px 24px rgba(82, 39, 255, 0.3)';
                e.currentTarget.style.borderColor = '#5227FF';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = 'transparent';
              }}
            >
              <h3 style={{
                fontSize: '1.5625rem',
                fontWeight: '300',
                marginBottom: '0.2rem',
                color: 'white'
              }}>
                {feature.title}
              </h3>
              <p style={{
                color: '#9ca3af',
                lineHeight: '1.6',
                fontSize: '1.25rem'
              }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;